module.exports = __webpack_public_path__ + "img/platformaIcon.3ba1947c.png";